module.exports = __webpack_public_path__ + "static/media/LinkedIn.7475b50c.svg";